import React, { useEffect, useRef, useState, useCallback } from "react";
import { ListBox } from "primereact/listbox";
import { SelectButton } from "primereact/selectbutton";
import { InputMask } from "primereact/inputmask";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tree } from "primereact/tree";
import kpiService from "@services/kpi.service";
import performanceManagementService from "@services/performanceManagement.service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ColorPicker } from "primereact/colorpicker";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import CodeMirror from "@uiw/react-codemirror";
import { EditorState } from "@codemirror/state";
import { autocompletion } from "@codemirror/autocomplete";
import { EditorView } from "@codemirror/view"
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { Toast } from 'primereact/toast';
import { MathComponent } from "mathjax-react";
import { Panel } from 'primereact/panel';

export default function KPIeditor_hfn() {
  const [nodes, setNodes] = useState([]);
  const [value, setValue] = useState("");
  const [name, setName] = useState("");
  const [update, setUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const onChange = useCallback((val, viewUpdate) => {

    setValue(val);
  }, []);

  useEffect(() => {
    kpiService
      .Get("/list/operator/hfn/")
      .then((response) => {
        let techs = {};
        let nodes = [];
        for (const kpi of response.data) {
          if (kpi.createBy !== "admin") {
            kpi.parent = "i" + kpi.parent;
          }
          if (!(kpi.parent in techs)) {
            techs[kpi.parent] = [];
            nodes.push({
              key: kpi.parent,
              label: kpi.parent,
              children: [],
            });
          }
          nodes
            .filter((p) => p.label === kpi.parent)[0]
            .children.push({ key: kpi._id, label: kpi.name });
        }
        setNodes(nodes);
      })
      .catch((err) => { });
  }, [update]);
  const [selectedTable, setSelectedTable] = useState(null);
  const tables = [
    { name: "2G_Avail", code: "2G_Avail" },
    { name: "2G_DCR", code: "2G_DCR" },
    { name: "2G_HO", code: "2G_HO" },
    { name: "2G_Quality", code: "2G_Quality" },
    { name: "3G_PART2", code: "3G_PART2" },
    { name: "5G_Interference", code: "5G_Interference" },
    { name: "5G_SLA", code: "5G_SLA" },
    { name: "5G_THR", code: "5G_THR" },
    { name: "LMBB_SLA", code: "LMBB_SLA" },
  ];
  const onSelect = (event) => {
    kpiService
      .Post("/get", { _id: event.node.key })
      .then((response) => {
        // console.log(response);
        setValue(response.data.formula_id);
        setName(response.data.name);
        setId(response.data._id);
        loadCounters(response.data.table, false);
        setSelectedTable({
          name: response.data.table,
          code: response.data.table,
        });
      })
      .catch((err) => { });
  };
  const deleteKpi = () => {
    if (id != null) {
      kpiService
        .Post("/delete/", { _id: id })
        .then((response) => {
          setValue("");
          setName("");
          setId(null);
          setSelectedTable(null);
          toast.current.show({ severity: 'success', summary: 'success', detail: 'Success' });
          setUpdate(!update);
        })
        .catch((err) => {
          toast.current.show({ severity: 'error', summary: 'error', detail: 'Error' });
        });
    }
  }
  const dropDownChange = (e) => {
    loadCounters(e.value.code, true);
  };

  const loadCounters = (table, reset) => {
    kpiService
      .Post("/get/hfn/counters", { table: table })
      .then((response) => {
        let list = [
          { label: "SUM", type: "keyword" },
          { label: "AVG", type: "keyword" },
          { label: "MAX", type: "keyword" },
          { label: "MIN", type: "keyword" },
        ];
        for (const counter of response.data) {
          list.push({ label: counter, type: "constant" });
        }
        if (reset) {
          setValue("");
          setId(null);
          setName("");

        }
        setCompletions(list);

      })
      .catch((err) => { });

    setSelectedTable({
      name: table,
      code: table,
    });
  }
  const test = () => {
    if (selectedTable !== null && name.length !== 0 && value.length !== 0) {
      setLoading(true);
      kpiService
        .Post("/hfn/test", {
          table: selectedTable.code,
          fourmula: value,
        })
        .then((response) => {
          toast.current.show({ severity: 'success', summary: 'success', detail: 'Success' });
          setLoading(false);
          setUpdate(true);
        })
        .catch((err) => {
          toast.current.show({ severity: 'error', summary: 'error', detail: 'Error' });
          setLoading(false);
        });

    }
    else {
      toast.current.show({ severity: 'error', summary: 'error', detail: 'Table and Name and fourmula are mandetory' });
    }

  };
  const save = () => {
    if (selectedTable !== null && name.length !== 0 && value.length !== 0) {
      setLoading(true);
      kpiService
        .Post("/hfn/upsert", {
          table: selectedTable.code,
          fourmula: value,
          id: id,
          name: name,
        })
        .then((response) => {
          if (response.data.message) {
            toast.current.show({ severity: 'error', summary: 'error', detail: response.data.message });
          }
          else {
            console.log(response.data);
            setId(response.data);
            toast.current.show({ severity: 'success', summary: 'success', detail: 'Success' });
          }

          setLoading(false);
          setUpdate(!update);
        })
        .catch((err) => {
          toast.current.show({ severity: 'error', summary: 'error', detail: 'Error' });
          setLoading(false);
        });

    }
    else {
      toast.current.show({ severity: 'error', summary: 'error', detail: 'Table and Name and fourmula are mandetory' });
    }

  };
  const newButtonClick = () => {
    setValue("");
    setSelectedTable(null);
    setName("");
    setId(null)
  }
  const startContent = (
    <React.Fragment>
      <Dropdown
        value={selectedTable}
        onChange={dropDownChange}
        options={tables}
        optionLabel="name"
        placeholder="Select a Table"
      />
      <InputText
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="w-96 mr-2"
      />
      <Button label="Test" loading={loading} icon="pi pi-caret-right" onClick={test} className="mr-2" />
      <Button label={id === null ? "Add" : "Update"} loading={loading} onClick={save} icon="pi pi-upload" className="p-button-success mr-2" />
      <Button label="New" onClick={newButtonClick} severity="warning" icon="pi pi-plus" className="mr-2" />
      <Button label="Search Counters" onClick={() => setVisible(true)} icon="pi pi-search" className="mr-2" />

    </React.Fragment>
  );
  const endContent = (
    <React.Fragment>
      <Button label="Delete" onClick={deleteKpi} severity="danger" className="mr-2" />
    </React.Fragment>
  );
  const [completions, setCompletions] = useState([]);

  function myCompletions(context) {
    let before = context.matchBefore(/\w+/);
    // If completion wasn't explicitly started and there
    // is no word before the cursor, don't open completions.
    if (!context.explicit && !before) return null;
    return {
      from: before ? before.from : context.pos,
      options: completions,
      validFor: /^\w*$/,
    };
  }
  const GetMath = (value) => {
    if (!value) {
      return "";
    }
    value = value.replaceAll("_", "\\_").replaceAll("sum", "")
    var isPercent = false;
    if (value.indexOf("* 100") > 0) {
      value = value.replaceAll("* 100", "")
      isPercent = true;
    }
    if (value.indexOf("*100") > 0) {
      value = value.replaceAll("*100", "")
      isPercent = true;
    }
    let frac = value.split("/");
    if (frac.length === 2) {
      if (isPercent) {
        value = `100*\\frac{${frac[0]}}{${frac[1]}}`
      }
      else {
        value = `\\frac{${frac[0]}}{${frac[1]}}`
      }

    }
    return value;
  }
  const handlePaste = (event) => {
    console.log('Pasted value:', event);
    const pastedValue = event.clipboardData.getData('text');
    // Do something with the pasted value (e.g., update state)
    console.log('Pasted value:', pastedValue);
  };
  const [visible, setVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const search = () => {
    kpiService
      .Post("/hfn/search/counters", {
        q: searchValue,
      })
      .then((response) => {
        setSearchResult(response.data)
      })
      .catch((err) => {
        toast.current.show({ severity: 'error', summary: 'error', detail: 'Error' });

      });
  }
  return (
    <div className="grid grid-cols-12 grid-rows-1 gap-2">
      <div className="col-span-3">
        <div className="card flex justify-content-center">
          <Tree
            onSelect={onSelect}
            filter
            selectionMode="single"
            style={{ maxHeight: "680px", overflow: "auto" }}
            value={nodes}
            className="w-full md:w-30rem"
          />
        </div>
      </div>
      <div className="col-span-9">
        <div>
          <div>
            <Toolbar className="m-2" start={startContent} end={endContent} />
          </div>
          <div>
            {/* <Editor headerTemplate={header} value={text} onTextChange={(e) => setText(e.htmlValue)} style={{ height: '320px' }} /> */}
            <CodeMirror className="m-2"
              value={value}
              height="200px"
              extensions={[
                EditorState.transactionFilter.of((tr) => {
                  return tr.newDoc.lines > 1 ? [] : [tr];
                }),
                autocompletion({ override: [myCompletions] }),
                EditorView.lineWrapping
              ]}
              onChange={onChange}
              onPaste={handlePaste}
              options={{
                theme: "material",
                lineNumbers: true,
                lineWrapping: true,
              }}
            />
          </div>
          <div>

            <Panel header="MATH View" className="m-2">
              <p className="m-0">
                <div style={{ "overflow-x": "auto", "white-space": "nowrap" }}>
                  <MathComponent tex={GetMath(value)} />
                </div>
              </p>
            </Panel >
            <Panel header="Help" className="m-2">
              <p className="m-1">
                You must use aggregation function for your fourmula.Allowed aggregations are : <b>SUM,AVG,MIN,MAX</b>
              </p>
              <p className="m-1">
                Use <b>crtl+space</b> to see all available counter related to selected table.
              </p>
              <p className="m-1">
                All counters use <b>"_"</b> instead of <b>"." and "-"</b>.If you copy your fourmula it automaticall replace all "." with "_".
              </p>
            </Panel >
            <Toast ref={toast} />
            <Dialog header="Header" visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
              <div className="m2">
                <InputText value={searchValue} placeholder="part of counter name" className="w-96 m-2" onChange={(e) => setSearchValue(e.target.value)} />
                <Button label="Search" onClick={search} className="m-2" />It just show top 20 results
              </div>
              <div className="m2">
                <DataTable value={searchResult} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="TABLE_NAME" header="TABLE_NAME"></Column>
                  <Column field="COLUMN_NAME" header="COLUMN_NAME"></Column>
                </DataTable>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  );
}
